// extracted by mini-css-extract-plugin
export var layoutContainer = "_ak-0";
export var layoutContainerNoRounding = "_ak-6";
export var layoutContainerOpen = "_ak-5";
export var layoutContainerResizing = "_ak-1";
export var mainContent = "_ak-2";
export var resizeDivider = "_ak-3";
export var slidePanel = "_ak-4";